import styled from 'styled-components';

const Tab = ({
  tab,
  setTab,
  setCurrentPage,
  isOnlySale,
}: {
  tab: string;
  setTab: (value: string) => void;
  setCurrentPage: (value: number) => void;
  isOnlySale: boolean;
}) => {
  return (
    <TabBox>
      <TabItem
        active={tab === '매매'}
        onClick={() => {
          setTab('매매');
          setCurrentPage(1);
        }}
      >
        매매
      </TabItem>
      {!isOnlySale && (
        <TabItem
          active={tab === '전˙월세'}
          onClick={() => {
            setTab('전˙월세');
            setCurrentPage(1);
          }}
        >
          전˙월세
        </TabItem>
      )}
    </TabBox>
  );
};

export default Tab;

interface TabItemProps {
  active: boolean;
}

const TabBox = styled.div`
  width: 100%;
  height: 39px;
  background-color: rgba(112, 115, 124, 0.05);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  padding: 4px;
`;

const TabItem = styled.div<TabItemProps>`
  flex: 1;
  // height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  background-color: ${({ active }) => (active ? 'white' : 'transparent')};
  color: ${({ active }) => (active ? '#222' : '#989BA2')};

  box-shadow: ${({ active }) =>
    active ? '0px 0px 1px rgba(56, 58, 59, 0.08)' : 'none'};

  border-radius: 8px;
  cursor: pointer;
  position: relative;

`;
